<template>
<div>
  <iframe name="iframe_login" style="display:none;">
  </iframe>
  <v-dialog
    persistent
    max-width="600px"
    :value="value"
    @click:outside="closeDialog"
    >
    <v-form
      ref="form_login"
      action="/udpes/api/dummy"
      target="iframe_login"
      @submit.prevent="send_login"
      >
      <v-toolbar
        >
        <v-toolbar-title>登入</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-toolbar>
    <v-card>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="user_id"
                label="帳號"
                required
                />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="pwd"
                label="密碼"
                type="password"
                required
                />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="closeDialog"
          >取消</v-btn>
        <v-btn
          type="submit"
          color="blue darken-1"
          text
          >送出</v-btn>
      </v-card-actions>
    </v-card>
    </v-form>
  </v-dialog>
</div>
</template>
<script>
import {get_login_by_user} from "@/api"
import {debug} from "@/api/logging"
export default {
  methods: {
    closeDialog() {
      this.$emit('input', false)
    },
    send_login() {
      // debug(this.$refs.form_login)
      // debug(this.$refs.form_login.$el)
      // debug(this.$refs.form_login && this.$refs.form_login.$el)
      if(this.$refs.form_login && this.$refs.form_login.$el) {
        this.$refs.form_login.$el.submit()
      }
      get_login_by_user(this.user_id, this.pwd)
      this.closeDialog()
    },
  },
  watch: {
    value() {
      this.user_id = this.pwd = undefined
    },
  },
  data() {
    return {
      user_id: undefined,
      pwd: undefined,
    }
  },
  props: {
    value: {},
  },
}
</script>
